import io from 'socket.io-client';

const getSocketUrl = () => {
    if (typeof window !== 'undefined' && window.location) {
        const { hostname, origin } = window.location;
        const isNative = Boolean(window.Capacitor && typeof window.Capacitor.isNativePlatform === 'function' && window.Capacitor.isNativePlatform());
        if (!isNative && hostname && hostname !== 'localhost' && hostname !== '127.0.0.1' && !origin.includes('localhost:3000')) {
            return origin;
        }
    }
    return 'http://184.107.156.47:3015';
};

const SOCKET_URL = getSocketUrl();

console.log('[Socket] Conectando em:', SOCKET_URL);

export const socket = io(SOCKET_URL, {
    autoConnect: true,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 2000,
    transports: ['polling', 'websocket'],  // Polling primeiro (funciona com IIS/proxy), depois tenta upgrade para WS
    upgrade: true,                          // Permite upgrade para WebSocket após conectar por polling
    forceNew: true,
    path: '/socket.io',
});

export const connectSocket = () => {
    if (!socket.connected) {
        console.log('[Socket] Forçando conexão...');
        socket.connect();
    }
};

export const disconnectSocket = () => {
    if (socket.connected) {
        socket.disconnect();
    }
};
